import React, { useEffect } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import SolicitudExitosaMobile from './estadoCuentaMobile/solicitudExitosaMobile.js';
import SolicitudExitosaDesktopp from './estadoCuentaDesktop/solicitudExitosaDesktop.js';


export default function SolicitudExitosa() {
    const { isMobile } = useIsMobile();

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Bank Statement Success Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <SolicitudExitosaDesktopp/>
                    : isMobile === 'movile'
                        ? null
                        : <SolicitudExitosaMobile />
                : null
            }
        </>
    )
}